import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_REVIEW_PAGE_NAME } from '../../../constants/service/app/recommendReviewConstants';
import RecommendReviewListContainer from '../../../containers/recommend/review/RecommendReviewListContainer';

const RecommendReviewList = () => {
  return (
    <PageTemplate pageName={RECOMMEND_REVIEW_PAGE_NAME.RECOMMEND_REVIEW_LIST}>
      <RecommendReviewListContainer />
    </PageTemplate>
  );
};

export default RecommendReviewList;
